import React, { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import ComponentPageTitle from '../../components/PageTitle';
import CenteredContainer from '../../components/CenteredContainer';
import Spacer from '../../components/Spacer';
import CircleNum from '../Works/mini_components/CircleNum';
import PageName from '../../components/PageName';
import SpanBold from '../../components/SpanBold';
import ProductPageH2 from '../Works/mini_components/ComponentProductPageH2';

import { OpenInNewOutlined } from '@mui/icons-material';





const ProfileHobby = () => {
    PageName("趣味 - プロフィール");

    return (<>
        <Header />
        <CenteredContainer>
        <ComponentPageTitle title="趣味 - プロフィール" />

        <SpanBold>BeRehearsal.</SpanBold>は、<SpanBold>BeReal.</SpanBold>のクローンアプリです。<br />



        {/* ================================================== 工夫点 ================================================== */}
        <ProductPageH2>ユーザーの使いやすさのために工夫した点</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>ユーザーの使いやすさのために、次のn点を工夫しました。</p>

            <Spacer height={20} />
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>本家と同じ操作性　</span>なるべく本家と同じ操作性でユーザーが使えるよう、UI/UXを設計しました。
                <p style={{ marginLeft: '30px', marginTop: '20px', fontSize: '16px' }}>例：撮影画面 <span style={{ fontSize: '13px' }}>（最新バージョンのBeReal.のUIに追いついていませんが、おおむね同じ操作性で使用することができます）</span></p>
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                        {/* <img src={BeRehearsal5} alt="工夫点1-1" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} /> */}
                        ↑ BeReal.
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                        {/* <img src={BeRehearsal6} alt="工夫点1-2" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} /> */}
                        ↑ BeRehearsal.
                    </div>
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>スタート画面スキップ　</span>起動時に瞬時に撮影画面の表示を可能にさせ、ユーザー体験向上に努めました。
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    {/* <img src={BeRehearsal7} alt="工夫点2" style={{ width: '100%', maxWidth: '320px', margin: '10px 0' }} /> */}
                </p>
            </p>
            <Spacer height={20} />
            <p>
                <CircleNum>3</CircleNum><span style={{fontWeight: 'bold'}}>左利きモード　</span>左利きのユーザーが快適に使用できるよう、ボタンの配置などを反転させる機能を実装しました。
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    {/* <img src={BeRehearsal8} alt="工夫点3" style={{ width: '100%', maxWidth: '320px', margin: '10px 0' }} /> */}
                </p>
            </p>
        </ul>
        {/* ========================================================================================================== */}


        </CenteredContainer>
        <Footer />
    </>);
};



export default ProfileHobby;